export default Object.freeze({
  ExecuteScheduledRun: 1,
});
